import { render, staticRenderFns } from "./Placeholder.vue?vue&type=template&id=1b7c7143&scoped=true"
import script from "./Placeholder.vue?vue&type=script&lang=js"
export * from "./Placeholder.vue?vue&type=script&lang=js"
import style0 from "./Placeholder.vue?vue&type=style&index=0&id=1b7c7143&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7c7143",
  null
  
)

export default component.exports